export default __webpack_public_path__ + "static/media/lockIcon.696bdfc1.svg";